import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { DtoConfirmationDialogData } from '../../../core';
import { MarkdownPipe } from '../../pipes/markdown.pipe';

@Component({
  selector: 'app-confirmation-dialog',
  imports: [MarkdownPipe, MatButtonModule, MatDialogModule],
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent {
  //#region Protected Fields --------------------------------------------------
  protected data: DtoConfirmationDialogData;
  //#endregion

  //#region Constructor & C° --------------------------------------------------
  constructor(@Inject(MAT_DIALOG_DATA) data: DtoConfirmationDialogData) {
    this.data = data;
  }
  //#endregion
}
